import React, { useState, useEffect, useRef } from 'react';
import './MethodDetail.css';
import methodsData from './methods.json';
import hljs from 'highlight.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons';


const MethodDetail = (props) => {
    const { match, location } = props;
    const queryParams = new URLSearchParams(location.search);
    const urlServiceType = queryParams.get('serviceType');
    const [serviceType, setServiceType] = useState('REST');
    const [responses, setResponses] = useState([]);


    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedCode, setSelectedCode] = useState('');
    const [responseDropdownOpen, setResponseDropdownOpen] = useState(null);
    const [responseDetails, setResponseDetails] = useState(null);
    const [methodHeader, setMethodHeader] = useState({});
    const [methodDescription, setMethodDescription] = useState('');
    const [bodyParams, setBodyParams] = useState([]);
    const [paramValues, setParamValues] = useState({});
    const [isCopied, setIsCopied] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('CSharp');

    const getCurrentDomain = () => {
        const url = new URL(window.location.href);
        return url.origin;
    };

    const constructServiceUrl = (serviceType, methodName) => {
        const domain = getCurrentDomain();
        if (serviceType === 'SOAP') {
            return `${domain}/edonusum/services/kolayWS?wsdl`;
        } else {
            return `${domain}/edonusum/api/document/${methodName}`;
        }
    };

    useEffect(() => {
        if (urlServiceType === 'SOAP' || urlServiceType === 'REST') {
            setServiceType(urlServiceType);
        }
    }, [match.params.methodName, urlServiceType]);

    useEffect(() => {
        const methodName = match.params.methodName;
        const methodData = methodsData[methodName];
        if (methodData) {
            const codeExamplesKey = serviceType === 'REST' ? 'rest-code-examples' : 'soap-code-examples';
            const rawCode = methodData[codeExamplesKey] ? methodData[codeExamplesKey][selectedLanguage] : '';
            const codeToHighlight = hljs.highlightAuto(rawCode).value;
            setSelectedCode(codeToHighlight);
            setResponses(methodData.responses);
            setMethodHeader({
                ...methodData['method-header'],
                url: constructServiceUrl(serviceType, methodName)
            });
            setMethodDescription(methodData['method-description']);
            setBodyParams(methodData['body-params']);

            const defaultParamValues = {};
            methodData['body-params'].forEach(param => {
                if (param.values && param.values.length > 0) {
                    defaultParamValues[param.name] = param.values[0];
                }
            });
            setParamValues(defaultParamValues);
        }
    }, [match.params.methodName, serviceType, selectedLanguage]);

    const handleSelectLanguage = (languageKey) => {
        setSelectedLanguage(languageKey);
    };


    const handleServiceTypeChange = (event) => {
        const selectedServiceType = event.target.checked ? 'SOAP' : 'REST';
        setServiceType(selectedServiceType);
    };
    const handleCopy = () => {
        const urlInput = document.querySelector('.method-url-input');
        urlInput.select();
        document.execCommand('copy');
    };
    const handleCopyCode = () => {
        const codeLines = Array.from(document.querySelectorAll('.code-display .line-content'));
        const codeToCopy = codeLines.map(line => line.textContent).join('\n');

        if (navigator.clipboard) {
            navigator.clipboard.writeText(codeToCopy)
                .then(() => {
                    setIsCopied(true);
                    setTimeout(() => setIsCopied(false), 2000);
                })
                .catch(err => {
                    console.error('Kopyalama hatası:', err);
                    fallbackCopyTextToClipboard(codeToCopy);
                });
        } else {
            fallbackCopyTextToClipboard(codeToCopy);
        }
    };

    const fallbackCopyTextToClipboard = (text) => {
        try {
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);

            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (err) {
            console.error('Kopyalama hatası:', err);
        }
    };


    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);
    const handleInputChange = (name, value) => {
        setParamValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));
    };

    const renderCodeWithLineNumbersAndParams = (code, bodyParams, paramValues) => {
        const codeLines = code.split('\n').map((line, index) => {
            const isHtml = /<\/?[a-z][\s\S]*>/i.test(line);
            const content = isHtml ? line : hljs.highlightAuto(line).value;

            return (
                <div key={`code-line-${index}`} className="code-line">
                    <span className="line-number">{index + 1}</span>
                    <span className="line-content" dangerouslySetInnerHTML={{ __html: content }}></span>
                </div>
            );
        });

        const paramsLines = bodyParams.map((param, index) => {
            const paramValue = paramValues[param.name] || '';
            const lineContent = `${param.name}: ${paramValue}`;
            const highlightedLine = hljs.highlightAuto(lineContent).value;

            return (
                <div key={`param-line-${index}`} className="code-line">
                    <span className="line-number">{codeLines.length + index + 1}</span>
                    <span className="line-content" dangerouslySetInnerHTML={{ __html: highlightedLine }}></span>
                </div>
            );
        });

        return [...codeLines, ...paramsLines];
    };

    return (
        <div id="api-method-container">

            <div className="api-method">
                <div className="method-header">
                    <h1 className="method-title">{methodHeader.title}</h1>
                    <p className="method-description">{methodDescription}</p>
                    <div className="method-actions">
                        {serviceType === 'REST' && (
                            <span className={`method-type-label ${methodHeader.method === 'GET' ? 'get-method' : methodHeader.method === 'POST' ? 'post-method' : ''}`}>
        {methodHeader.method}
    </span>
                        )}

                        <input type="text" value={methodHeader.url} readOnly className="method-url-input"/>
                        <button className="copy-url-button" onClick={handleCopy}>Kopyala</button>
                    </div>
                </div>

                <div className="body-params">
                    {bodyParams.map((param, index) => (
                        <div className="param" key={index}>
                            <label className="param-label" htmlFor={param.name}>{param.name}</label>
                            <div className="param-info">
                                <span className="type">{param.type}</span>
                                {param.required && <span className="required">required</span>}
                            </div>
                            {param.values ? (
                                <select
                                    id={param.name}
                                    name={param.name}
                                    required={param.required}
                                    value={paramValues[param.name] || ''}
                                    onChange={(e) => handleInputChange(param.name, e.target.value)}
                                >
                                    {param.values.map((value, valueIndex) => (
                                        <option key={valueIndex} value={value}>{value}</option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    type={param.type === 'password' ? 'password' : 'text'}
                                    id={param.name}
                                    name={param.name}
                                    required={param.required}
                                    value={paramValues[param.name] || ''}
                                    onChange={(e) => handleInputChange(param.name, e.target.value)}
                                />
                            )}
                            <span className="param-description">{param.description}</span>
                        </div>
                    ))}
                </div>

                <div>
                    {responses.map((response, index) => (
                        <div key={index} className={`api-response ${responseDropdownOpen === index ? 'active' : ''}`}
                             onClick={() => response.details && response.details.length > 0 ? setResponseDropdownOpen(responseDropdownOpen === index ? null : index) : null}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <div className="status-circle" style={{backgroundColor: response.color}}></div>
                                <span className="status-code">{response.statusCode}</span>
                            </div>
                            <span className="status-text">{response.statusText}</span>
                            <span
                                className={`dropdown-arrow ${responseDropdownOpen === index && response.details && response.details.length > 0 ? 'open' : ''}`}>
                    {response.details && response.details.length > 0 ? '▼' : ''}
                </span>
                            {responseDropdownOpen === index && response.details && response.details.length > 0 && (
                                <div className="response-details" style={{display: 'block'}}>
                                    {response.details.map((detail, idx) => (
                                        <div key={idx} className="response-item">
                                            <span className="response-key">{detail.key}</span>
                                            <span className="response-value">{detail.value}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>


            <div className="code-examples-container">
                <div className="code-examples">
                    <div className="language-buttons-container">
                    <button className="language-button" onClick={() => handleSelectLanguage('CSharp')}>C#</button>
                        <button className="language-button" onClick={() => handleSelectLanguage('Java')}>Java</button>
                        <button className="language-button" onClick={() => handleSelectLanguage('PHP')}>PHP</button>
                        <label className="switch">
                            <input type="checkbox" id="togBtn" checked={serviceType === 'SOAP'}
                                   onChange={handleServiceTypeChange}/>
                            <div className="slider round">
                                <span className="on">SOAP</span>
                                <span className="off">REST</span>
                            </div>
                        </label>
                    </div>

                    <div className="code-display">
                        <FontAwesomeIcon
                            icon={isCopied ? faCheck : faCopy}
                            onClick={handleCopyCode}
                            className="copy-icon"
                            title={isCopied ? "Copied" : "Copy"}
                            size="2x"
                        />
                        {renderCodeWithLineNumbersAndParams(selectedCode, bodyParams, paramValues)}
                    </div>

                </div>
            </div>
        </div>
    );
};
export default MethodDetail;